export const NON_ADMIN_ROLES = ["org/employee", "tutor/student"];

export const getAdminProfiles = user => {
  const roles = (user && user.roles) || [];
  const profiles = (user && user.profiles) || [];
  return profiles.filter(profile => {
    return roles.some(
      role =>
        role.companyId == profile.company.id &&
        !NON_ADMIN_ROLES.includes(role.roleName)
    );
  });
};

export const getDefaultProfile = user => {
  return getAdminProfiles(user)[0] || user.profiles[0];
};
